import { render } from "./Songs.vue?vue&type=template&id=ef796e5c"
import script from "./Songs.vue?vue&type=script&lang=js"
export * from "./Songs.vue?vue&type=script&lang=js"

import "./Songs.vue?vue&type=style&index=0&id=ef796e5c&lang=css"
script.render = render

export default script